export enum AudienceEnum {
  SINGLE_USERS = 'SINGLE_USERS',
  ALL_USERS = 'ALL_USERS',
  ALL_USERS_IN_CHALLENGE = 'ALL_USERS_IN_CHALLENGE',
  ALL_USERS_IN_COMPANY = 'ALL_USERS_IN_COMPANY',
  ALL_USERS_IN_COMPETITION = 'ALL_USERS_IN_COMPETITION',
	TYPE = 'TYPE'
}
